// extracted by mini-css-extract-plugin
module.exports = {"registrationContainer":"_1tpLa","agreementContainer":"_3-6gj","agreement":"_2LFnA","agreementText":"_3_EdX","checkbox":"_3ec8h"};